import React, { PureComponent } from 'react';
import qp from 'query-parse';

import GifThumb from './gif-thumb';

export default class MessageGif extends PureComponent { 
    static defaultProps = {
        url: '',
        size: ''
    };

    render() {
        const [url, paramsString] = this.props.url.split('?');
        const params = qp.toObject(paramsString);

        return (
            <GifThumb url={url} width={params[`${this.props.size}width`]} height={params[`${this.props.size}height`]} />
        )
    }
}
